module.exports = __webpack_public_path__ + "static/media/top-user-banner-3.1c388798.jpg";